import React, { useState } from 'react'
import { Button, Checkbox, ComboboxData, Group, Modal, MultiSelect, Stack, Text } from '@mantine/core'
import { useGenerateReport, usePricingVersionCache, usePricingVersions } from '../../../../hooks/global-job-matching'
import { useParams } from 'react-router'

export enum GENERATE_REPORT_OPTIONS {
  PRICING_VERSION_DETAILS = "Market Pricing Details by Job",
  PRICING_VERSION_SUMMARY = "Market Pricing Composite Summary by Job",
  PRICING_VERSION_MATCH_PRIORITIES = "Matches Download",
  PRICING_VERSION_STATS = "Version Statistics"
}

type GenerateReportModalProps = {
  opened: boolean
  onClose: () => void
  reportOption: GENERATE_REPORT_OPTIONS
}

export const GenerateReportModal = ({ opened, onClose, reportOption }: GenerateReportModalProps) => {
  const params = useParams<{ id: string }>()
  const { data: versions = [] } = usePricingVersions()
  const { mutate, isLoading, isSuccess, reset } = useGenerateReport()
  const version = usePricingVersionCache(params.id)
  const [selectedVersions, setSelectedVersions] = useState<string[]>([version.name])
  const [includeOfficialPricing, setIncludeOfficialPricing] = useState(false)

  const multiSelectData: ComboboxData = versions?.map(v => v.name)

  const handleGenerateReport = () => {
    const categoryCode = reportOption === GENERATE_REPORT_OPTIONS.PRICING_VERSION_DETAILS ? 'market_pricing_versions_matches' : 'market_pricing_versions_summaries'
    const versionIds: number[] = []
    selectedVersions.forEach(sv => {
      const id = versions.find(v => v.name === sv)?.id
      if (id) versionIds.push(id)
    })
    mutate({ categoryCode, versionIds, includeOfficialPricing })
  }

  if (isSuccess) {
    reset()
    onClose()
  }

  return (
    <Modal size='xl' opened={opened} onClose={onClose}>
      <Stack>
        <Text size='lg'>Select Pricing Versions</Text>
        <Text>Select up to five pricing versions to include in the report.</Text>
        <MultiSelect h='100%' size='lg' data={multiSelectData} value={selectedVersions} maxValues={5} onChange={setSelectedVersions} />
        <Checkbox size='lg' label='Include Official Pricing' checked={includeOfficialPricing} onChange={e => setIncludeOfficialPricing(e.currentTarget.checked)} />
        <Group justify='flex-end'>
          <Button size='lg' variant='outline' onClick={onClose}>Cancel</Button>
          <Button size='lg' disabled={!selectedVersions.length || isLoading} loading={isLoading} onClick={handleGenerateReport}>Generate</Button>
        </Group>
      </Stack>
    </Modal>
  )
}
